/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type BookmarksWidgetContainer_user$ref: FragmentReference;
declare export opaque type BookmarksWidgetContainer_user$fragmentType: BookmarksWidgetContainer_user$ref;
export type BookmarksWidgetContainer_user = {|
  +id: string,
  +$refType: BookmarksWidgetContainer_user$ref,
|};
export type BookmarksWidgetContainer_user$data = BookmarksWidgetContainer_user;
export type BookmarksWidgetContainer_user$key = {
  +$data?: BookmarksWidgetContainer_user$data,
  +$fragmentRefs: BookmarksWidgetContainer_user$ref,
};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "BookmarksWidgetContainer_user",
  "type": "User",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "id",
      "args": null,
      "storageKey": null
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = '1116745567fbd3546789253d635752ac';
module.exports = node;
